export default __webpack_public_path__ + "static/media/m6.4d8f9bd7.png";